import { render } from "./SldDiy.vue?vue&type=template&id=4af7af90&scoped=true"
import script from "./SldDiy.vue?vue&type=script&lang=js"
export * from "./SldDiy.vue?vue&type=script&lang=js"

import "./SldDiy.vue?vue&type=style&index=0&id=4af7af90&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4af7af90"

export default script